import React from "react";
import "./PageSkeleton.css"; // Add skeleton styles

const PageSkeleton = () => {
    return (
        <div className="page-skeleton">
            <div className="skeleton skeleton-heading"></div>
            <div className="skeleton skeleton-box"></div>
            <div className="skeleton skeleton-text"></div>
            <div className="skeleton skeleton-text short"></div>
        </div>
    );
};

export default PageSkeleton;
